import { render, staticRenderFns } from "./fccMenuPrincipal.vue?vue&type=template&id=165fb7e2"
import script from "./fccMenuPrincipal.vue?vue&type=script&lang=js"
export * from "./fccMenuPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports